import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './BusinessModelTabs.scss';
import { 
  OverviewFlow, 
  ActivitiesFlow, 
  ResourcesFlow, 
  ValueFlow,
  RelationsFlow,
  ChannelsFlow,
  SegmentsFlow,
  RevenueFlow
} from './BusinessModelFlows';

const BusinessModelTabs = () => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState('overview');

  const tabs = [
    { id: 'overview', label: t('business_model_tabs.tab_overview') },
    { id: 'canvas', label: t('business_model_tabs.tab_canvas') },
    { id: 'activities', label: t('business_model_tabs.tab_activities') },
    { id: 'resources', label: t('business_model_tabs.tab_resources') },
    { id: 'value', label: t('business_model_tabs.tab_value') },
    { id: 'relations', label: t('business_model_tabs.relations.title') },
    { id: 'channels', label: t('business_model_tabs.channels.title') },
    { id: 'segments', label: t('business_model_tabs.segments.title') },
    { id: 'revenue', label: t('business_model_tabs.revenue.title') },
  ];

  return (
    <>
      <div className="business-model-tabs-wrapper">
      <h2 className="bmt-title">{t('business_model_tabs.title')}</h2>

      <div className="bmt-nav">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`bmt-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div 
        key={`${activeTab}-${i18n.language}`}
        className="bmt-content" 
        style={{ padding: '0', overflow: 'hidden', width: '100%' }}
      >
        
        {/* TAB 1: OVERVIEW */}
        {activeTab === 'overview' && (
          <OverviewFlow t={t} />
        )}

        {/* TAB 2: CANVAS (Flex Grouped Layout) */}
        {activeTab === 'canvas' && (
          <div className="tab-canvas" style={{ padding: '40px' }}>
            <div className="tab-canvas-flex">
              
              <div className="canvas-top">
                <div className="canvas-group left-group">
                  <div className="c-box bg-blue flex-2">{t('business_model_tabs.canvas.partners')}</div>
                  <div className="canvas-col flex-1">
                    <div className="c-box bg-green flex-1">{t('business_model_tabs.canvas.activities')}</div>
                    <div className="c-box bg-green flex-1">{t('business_model_tabs.canvas.resources')}</div>
                  </div>
                </div>

                <div className="center-group">
                  <div className="c-box bg-blue flex-1">{t('business_model_tabs.canvas.value')}</div>
                </div>

                <div className="canvas-group right-group">
                  <div className="canvas-col flex-1">
                    <div className="c-box bg-green flex-1">{t('business_model_tabs.canvas.relations')}</div>
                    <div className="c-box bg-green flex-1">{t('business_model_tabs.canvas.channels')}</div>
                  </div>
                  <div className="c-box bg-blue flex-2">{t('business_model_tabs.canvas.segments')}</div>
                </div>
              </div>

              <div className="canvas-bottom">
                <div className="c-box bg-blue">{t('business_model_tabs.canvas.costs')}</div>
                <div className="c-box bg-green">{t('business_model_tabs.canvas.revenue')}</div>
              </div>

            </div>
          </div>
        )}

        {/* TAB 3: ACTIVITIES */}
        {activeTab === 'activities' && (
          <ActivitiesFlow t={t} />
        )}

        {/* TAB 4: RESOURCES */}
        {activeTab === 'resources' && (
          <ResourcesFlow t={t} />
        )}

        {/* TAB 5: VALUE */}
        {activeTab === 'value' && (
          <ValueFlow t={t} />
        )}

        {/* TAB 6: RELATIONS */}
        {activeTab === 'relations' && (
          <RelationsFlow t={t} />
        )}

        {/* TAB 7: CHANNELS */}
        {activeTab === 'channels' && (
          <ChannelsFlow t={t} />
        )}

        {/* TAB 8: SEGMENTS */}
        {activeTab === 'segments' && (
          <SegmentsFlow t={t} />
        )}

        {/* TAB 9: REVENUE */}
        {activeTab === 'revenue' && (
          <RevenueFlow t={t} />
        )}

      </div>
    </div>

    {/* QR Code Section */}
    <div className="bmt-qr-section">
      <h3 
        className="bmt-qr-title" 
        dangerouslySetInnerHTML={{ __html: t('business_model_tabs.qr_scan_title') }} 
      />
      
      <div className="bmt-qr-banner-text">
        <div className="banner-slogan">{t('business_model_tabs.qr_banner_slogan')}</div>
        <div className="banner-title" dangerouslySetInnerHTML={{ __html: t('business_model_tabs.qr_banner_title') }}></div>
        <div className="banner-subtext">{t('business_model_tabs.qr_banner_subtext')}</div>
      </div>

      <div className="bmt-qr-images">
        <div className="bmt-qr-item">
          <img src="/images/qr/qr_google_play.png" alt="Google Play QR Code" />
        </div>
        <div className="bmt-qr-item">
          <img src="/images/qr/qr_app_store.png" alt="App Store QR Code" />
        </div>
      </div>
    </div>
  </>
  );
};

export default BusinessModelTabs;
